import React, {
    useState, useEffect, useCallback,
} from 'react';
import debounce from 'lodash/debounce';
import {
    FaCopy,
} from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import DeleteButton from 'react-bootstrap/CloseButton';
import { useDispatch } from 'react-redux';


const TextInput = ({
    value,
    onChange,
    onFocus,
    placeholder,
    type,
    disabled,
    showClose,
    showCopy,
    ...props
}) => {
    const [inputValue, setInputValue] = useState(value);
    const dispatch = useDispatch();

    useEffect(() => {
        debounceOnChange(inputValue);
    }, [inputValue]);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const debounceOnChange = useCallback(
        debounce((value) => {
            if (!onChange) {
                return;
            }
            onChange({
                target: {
                    value,
                },
            });
        }, 0),
        [],
    );

    const copyToClipboard = () => {
        navigator.clipboard.writeText(inputValue);
        dispatch({
            type: 'messages/addMessage',
            payload: {
                title: 'Text Copied',
                message: `Copied "${inputValue}" to clipboard`,
                delay: 2000,
            },
        });
    };

    return (
        <div className="mb-3 d-flex">
            <div className="position-relative flex-grow-1">
                <input
                    type={type}
                    className="form-control"
                    value={inputValue}
                    onChange={(e) => {
                        setInputValue(e.target.value);
                    }}
                    placeholder={placeholder}
                    disabled={disabled}
                    onFocus={onFocus}
                    {...props}
                />
                {
                    showClose && !disabled && (
                        <DeleteButton
                            className="position-absolute top-50 end-0 translate-middle-y"
                            onClick={() => {
                                setInputValue('');
                            }}
                            style={{
                                padding: '0 8px',
                                width: '20px',
                            }}
                        />
                    )
                }
            </div>
            {
                showCopy && (
                    <Button
                        className="ms-1"
                        variant="outline-secondary"
                        onClick={copyToClipboard}
                    >
                        <FaCopy />
                    </Button>
                )
            }
        </div>
    );
};

export default TextInput;
